import { createFileRoute, redirect } from "@tanstack/react-router";

// Old WordPress media/attachment page — 301 to the front page.
export const Route = createFileRoute("/mi-support-logo")({
  beforeLoad: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
